class Coverage {
  coverageCode: string | null
  sumInsured: string | null

  constructor(data: Coverage) {
    if (!data.coverageCode) throw new Error('coverageCode is required')

    this.coverageCode = data.coverageCode
    this.sumInsured = data.sumInsured ?? null
  }
}

class HealthInsured {
  postalCode: string | null
  birthDate: string | null
  riskNumber: string | null
  optionalCoverage?: Coverage[] | undefined

  constructor(data: HealthInsured) {
    if (!data.postalCode) throw new Error('postalCode is required')
    if (!data.birthDate) throw new Error('birthDate is required')
    if (!data.riskNumber) throw new Error('riskNumber is required')

    this.postalCode = data.postalCode
    this.birthDate = data.birthDate
    this.riskNumber = data.riskNumber
    this.optionalCoverage =
      data.optionalCoverage?.map((coverage) => new Coverage(coverage)) ?? undefined
  }
}

export class SimpleRaterRequest {
  businessLine: string | null
  insuranceStartDate: string | null
  insuranceType: string | null
  stayAbroadType: string | null | undefined
  // copaymentType -> filter value after
  policyHolderPostal: string | null
  insureds: HealthInsured[]

  constructor(data: SimpleRaterRequest) {
    if (!data.businessLine) throw new Error('businessLine is required')
    if (!data.insuranceStartDate) throw new Error('insuranceStartDate is required')
    if (!data.insuranceType) throw new Error('insuranceType is required')
    if (!data.policyHolderPostal) throw new Error('policyHolderPostal is required')
    if (!data.insureds) throw new Error('insureds is required')

    this.businessLine = data.businessLine
    this.insuranceStartDate = data.insuranceStartDate
    this.insuranceType = data.insuranceType
    this.stayAbroadType = data.stayAbroadType ?? undefined
    this.policyHolderPostal = data.policyHolderPostal
    this.insureds = data.insureds.map((insured) => new HealthInsured(insured))
  }
}

export class ProductRaterRequest {
  clientProduct: { clientCode: string | null; productCode: string | null }[]
  businessLine: string | null
  insuranceStartDate: string | null
  insuranceType: string | null | undefined
  stayAbroadType: string | null | undefined
  // copaymentType -> filter value after
  policyHolderPostal: string | null
  insureds: HealthInsured[]
  isQuote: boolean = false

  constructor(data: ProductRaterRequest) {
    if (data.clientProduct.some((c) => !c.clientCode || !c.productCode)) {
      throw new Error('clientCode and productCode are required')
    }
    if (!data.businessLine) throw new Error('businessLine is required')
    if (!data.insuranceStartDate) throw new Error('insuranceStartDate is required')
    if (!data.policyHolderPostal) throw new Error('policyHolderPostal is required')
    if (!data.insureds) throw new Error('insureds is required')

    this.clientProduct = data.clientProduct
    this.businessLine = data.businessLine
    this.insuranceStartDate = data.insuranceStartDate
    this.insuranceType = data.insuranceType ?? undefined
    this.stayAbroadType = data.stayAbroadType ?? undefined
    this.policyHolderPostal = data.policyHolderPostal
    this.insureds = data.insureds.map((insured) => new HealthInsured(insured))
    this.isQuote = data.isQuote
  }
}

export class ModifiedRaterRequest {
  quotationId: string | null
  quotationNumber: string | null
  businessLine: string | null
  insuranceStartDate: string | null
  insuranceType: string | null | undefined
  stayAbroadType: string | null | undefined
  // copaymentType -> filter value after
  policyHolderPostal: string | null
  insureds: HealthInsured[]
  isQuote: boolean = false

  constructor(data: ModifiedRaterRequest) {
    if (!data.quotationId) throw new Error('quotationId is required')
    if (!data.quotationNumber) throw new Error('quotationNumber is required')

    this.quotationId = data.quotationId
    this.quotationNumber = data.quotationNumber
    this.businessLine = data.businessLine
    this.insuranceStartDate = data.insuranceStartDate
    this.insuranceType = data?.insuranceType ?? undefined
    this.stayAbroadType = data?.stayAbroadType ?? undefined
    this.policyHolderPostal = data.policyHolderPostal
    this.insureds = data.insureds.map((insured) => new HealthInsured(insured))
    this.isQuote = data.isQuote
  }
}
